const partners = [
  {
    role: 'Technology & Execution Partner',
    name: 'XPEC Innovations',
    desc: 'Platforms, data systems, digital applications and delivery at scale.',
    icon: 'ri-cpu-line',
  },
  {
    role: 'Research & Strategic Partner',
    name: 'NKPR Promotion',
    desc: 'Surveys, field research, strategy and stakeholder engagement.',
    icon: 'ri-focus-3-line',
  },
];

const credentials = [
  'Registered joint venture',
  'Experienced execution teams',
  'Field research & survey capability',
  'Digital & communication platforms',
  'Public sector delivery experience',
];

export default function Partners() {
  return (
    <section className="relative w-full bg-background-100/60 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-fine opacity-50 mask-radial-fade pointer-events-none"></div>

      <div className="relative px-6 md:px-16 lg:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Copy */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">09 / Partners & Credentials</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950 tracking-tight font-semibold">
              Built by two capable partners, <span className="text-primary-700">as one</span>.
            </h2>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '120ms' }} className="mt-6 max-w-lg text-[15px] md:text-base leading-[1.8] text-foreground-600">
              Prabhaw brings together execution and insight under one roof — the
              depth of a technology firm with the rigour of a research and strategy
              practice.
            </p>
          </div>

          {/* Partner cards */}
          <div data-reveal-stagger className="flex flex-col gap-5">
            {partners.map((p) => (
              <div key={p.name} className="stagger-child flex items-start gap-5 rounded-2xl border border-background-200 bg-background-50 p-7 hover:bg-background-100 transition-colors">
                <span className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center text-primary-700 shrink-0">
                  <i className={`${p.icon} w-7 h-7 flex items-center justify-center`}></i>
                </span>
                <div>
                  <p className="text-[11px] tracking-[0.22em] uppercase text-foreground-500 font-mono">{p.role}</p>
                  <h3 className="mt-1 text-2xl text-foreground-950 font-semibold tracking-wide">{p.name}</h3>
                  <p className="mt-1.5 text-[14px] leading-[1.7] text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Credentials */}
        <div data-reveal="fade" className="mt-14 grid grid-cols-2 md:grid-cols-5 gap-4 border-t border-background-200 pt-10">
          {credentials.map((c) => (
            <div key={c} className="flex items-center gap-2.5">
              <i className="ri-check-double-line w-5 h-5 flex items-center justify-center text-accent-600 shrink-0"></i>
              <span className="text-[13px] leading-snug text-foreground-600">{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}